import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import {
  getParsedEmployee,
  getParsedEmployeeInternal,
} from 'src/selectors/employee.selector';
import { IEmployee, IEmployeeDetails } from 'src/models/employee.model';
import services from 'src/services/employee.service';

export const actionTypes = {
  EMPLOYEE_SEARCH_FETCH: 'EMPLOYEE_SEARCH_FETCH',
  EMPLOYEE_USER_LIST_FETCH: 'EMPLOYEE_USER_LIST_FETCH',
  EMPLOYEE_USER_FETCH: 'EMPLOYEE_USER_FETCH',
  EMPLOYEE_SEARCH_INTERNAL_FETCH: 'EMPLOYEE_SEARCH_INTERNAL_FETCH',
  EMPLOYEE_DEFAULT: 'EMPLOYEE_DEFAULT',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  defaultGET: {
    type: actionTypes.EMPLOYEE_DEFAULT,
    service: services.searchGET,
  },
  searchGET: {
    type: actionTypes.EMPLOYEE_SEARCH_FETCH,
    service: services.searchGET,
  },
  usersPOST: {
    type: actionTypes.EMPLOYEE_USER_LIST_FETCH,
    service: services.usersPOST,
  },
  userGET: {
    type: actionTypes.EMPLOYEE_USER_FETCH,
    service: services.userGET,
  },
  searchInternalGET: {
    type: actionTypes.EMPLOYEE_SEARCH_INTERNAL_FETCH,
    service: services.searchInternalGET,
  },
};

export type IEmployeeAsync = typeof asyncActions;

export interface IEmployeeState extends ICommonState<IEmployeeAsync> {
  list: IEmployee[];
  searchList: IEmployee[];
  loggedInUser?: IEmployeeDetails;
}

export const defaultState: IEmployeeState = {
  status: {},
  list: [],
  searchList: [],
};

const EmployeeReducer = (
  state: IEmployeeState = defaultState,
  action: IReducerAction<IEmployeeAsync>
): IEmployeeState => {
  switch (action.type) {
    case actionTypes.EMPLOYEE_SEARCH_FETCH: {
      return {
        ...state,
        list: (action.payload ?? []).map((employee) =>
          getParsedEmployee(employee)
        ),
      };
    }
    case actionTypes.EMPLOYEE_USER_LIST_FETCH: {
      return {
        ...state,
        list: (action.payload?.rows ?? []).map((employee) =>
          getParsedEmployee(employee)
        ),
      };
    }
    case actionTypes.EMPLOYEE_SEARCH_INTERNAL_FETCH: {
      return {
        ...state,
        searchList: (action.payload?.employees ?? []).map((employee) =>
          getParsedEmployeeInternal(employee)
        ),
      };
    }
    case actionTypes.EMPLOYEE_USER_FETCH: {
      return {
        ...state,
        loggedInUser: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default EmployeeReducer;
